import { z } from 'zod';
/**
 * Umumiy primitivlar. Har schema shulardan quriladi — bir xil narsa ikki xil
 * yozilmasligi uchun.
 */
/** Barcha birlamchi kalitlar — UUID. */
export const IdSchema = z.string().uuid();
/** Sana va vaqt transport qatlamida ISO 8601 string. `Date` obyekt yurmaydi. */
export const IsoDateTimeSchema = z.string().datetime({ offset: true });
/** Faqat sana (`@db.Date`): "2026-09-03". */
export const IsoDateSchema = z.string().date();
/** Telefon — O'zbekiston formati, faqat raqamlar va `+`. */
export const PhoneSchema = z
    .string()
    .trim()
    .regex(/^\+998\d{9}$/, "Telefon +998XXXXXXXXX ko'rinishida bo'lishi kerak");
/** Slug — URL da ishlatiladi, kichik harf va defis. */
export const SlugSchema = z
    .string()
    .min(1)
    .max(160)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug faqat kichik harf, raqam va defisdan iborat');
/**
 * Matndan slug yasaydi. `SlugSchema` ning YONIDA turadi — generator va
 * tekshiruvchi ajralib ketmasligi uchun (ular birga sinaladi).
 *
 * O'zbek lotinidagi tutuq belgisi (`o'`, `g'`, `ʻ`, `'`) TASHLANADI,
 * defisga aylantirilmaydi: "mo'y" -> "moy", "mo-y" emas.
 *
 * Kirill harflari TRANSLITERATSIYA QILINMAYDI. Sabab: bir necha xil
 * transliteratsiya standarti bor va noto'g'ri tanlangani URL'ni bir
 * marta buzsa, uni keyin tuzatib bo'lmaydi (havolalar eskiradi). Ruscha
 * nomdan slug kerak bo'lsa, uni odam yozadi — shuning uchun kirill
 * kirishda `null` qaytadi, jimgina bo'sh string emas.
 *
 * @returns `SlugSchema` ga mos string, yoki hech narsa qolmasa `null`
 */
export function toSlug(input, maxLength = 160) {
    const slug = input
        .toLowerCase()
        // Tutuq belgilari — turli Unicode variantlari bilan.
        .replace(/['\u2018\u2019\u02bb\u02bc`]/gu, '')
        .replace(/[^a-z0-9]+/gu, '-')
        .replace(/^-+|-+$/gu, '')
        .slice(0, maxLength)
        // Kesishdan keyin oxirida defis qolishi mumkin.
        .replace(/-+$/u, '');
    return slug === '' ? null : slug;
}
/**
 * Ikki tilli maydon.
 *
 * `*Uz` MAJBURIY, `*Ru` ixtiyoriy. Javobda `*Ru` bo'sh bo'lsa klient
 * `*Uz` ga tushadi — bu qoida `pickLocalized` da bir joyda yozilgan
 * (avtopart-i18n skill).
 */
export const requiredText = (max) => z.string().trim().min(1).max(max);
export const optionalText = (max) => z.string().trim().max(max).optional();
/** Javobda ixtiyoriy matn `null` bo'lib keladi (Prisma `String?`). */
export const nullableText = (max) => z.string().max(max).nullable();
export const LocaleSchema = z.enum(['UZ', 'RU']);
/**
 * `*Ru` bo'sh bo'lsa `*Uz` ga tushadi. Komponentlarda `?? ''` yozilmaydi —
 * har doim shu funksiya ishlatiladi.
 */
export function pickLocalized(uz, ru, locale) {
    if (locale === 'RU') {
        const trimmed = ru?.trim();
        if (trimmed !== undefined && trimmed !== '')
            return trimmed;
    }
    return uz;
}
/** Ro'yxat so'rovlari uchun sahifalash. Kursorli, offsetli emas. */
export const PaginationQuerySchema = z
    .object({
    limit: z.coerce.number().int().min(1).max(100).default(24),
    cursor: z.string().max(255).optional(),
})
    .strict();
/** Sahifalangan javob. Har ro'yxat endpointi shu shaklda qaytaradi. */
export function paginated(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
        total: z.number().int().nonnegative(),
    });
}
/** Faqat id qaytaradigan amallar uchun (yaratish, o'chirish). */
export const IdResponseSchema = z.object({ id: IdSchema });
//# sourceMappingURL=common.js.map